import * as React from "react";
import { getMBNValueHelper } from "../getMBNValueHelper";
import { getMBNIndicationClassHelper } from "../getMBNIndicationClassHelper";
import { EventMBNNumber } from "../../blocks/SuperBanner/components";
export function getMBNComponentHelper(shouldMBNRender, pickedEvent, clsMdf) {
    if (shouldMBNRender && pickedEvent && pickedEvent.market && pickedEvent.market.name) {
        let MBNNumber = getMBNValueHelper(pickedEvent.market.tags);
        clsMdf = clsMdf ? clsMdf : new Array();
        clsMdf.push("min-bet-number", getMBNIndicationClassHelper(MBNNumber));
        return React.createElement(EventMBNNumber, { text: MBNNumber, modifier: clsMdf });
    }
    return undefined;
}
//# sourceMappingURL=getMBNComponentHelper.js.map